import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectContactPerson, selectClientName, selectEmail, selectPhoneNumber, selectShowInvalids } from '@store/partners-registration/selectors';
import { setContactPerson, setClientName, setEmail, setPhoneNumber } from '@store/partners-registration/slice';
import TextField from '@components/text-field/TextField';
import { invalidFormValue, isValidEmail, isValidPhoneNumber } from '@components/utils';



const CLientInfo = () => {
	const { t } = useTranslation('forms');

	const contactPerson = useSelector(selectContactPerson);
	const clientName = useSelector(selectClientName);
	const email = useSelector(selectEmail);
	const phoneNumber = useSelector(selectPhoneNumber);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateContactPerson = (value: string | null) => dispatch(setContactPerson(value));
	const updateClientName = (value: string | null) => dispatch(setClientName(value));
	const updateEmail = (value: string | null) => dispatch(setEmail(value));
	const updatePhoneNumber = (value: string | null) => dispatch(setPhoneNumber(value));

	return (
		<div className='client-info-section'>

			<TextField
				label={t('inputLabels.contactPerson')}
				required={true}
				value={contactPerson ? contactPerson : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateContactPerson(null) : updateContactPerson(value)}
				errorMessage={showInvalids && invalidFormValue(contactPerson) ? t('validation.requiredField') : undefined} />

			<TextField
				label={t('inputLabels.client')}
				required={true}
				value={clientName ? clientName : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateClientName(null) : updateClientName(value)}
				errorMessage={showInvalids && invalidFormValue(clientName) ? t('validation.requiredField') : undefined} />

			<TextField
				label={t('inputLabels.email')}
				required={true}
				value={email ? email : undefined}
				rounded={true}
				maxLength={50}
				onChange={(value: string) =>
					!value && value.length === 0 ? updateEmail(null) : updateEmail(value)}
				errorMessage={showInvalids && invalidFormValue(email)
					? t('validation.requiredField')
					: showInvalids && !isValidEmail(email)
					? t('validation.incorrectEmailFormat')
					: undefined} />

			<TextField
				label={t('inputLabels.phone')}
				required={true}
				value={phoneNumber ? phoneNumber : undefined}
				rounded={true}
				maxLength={16}
				onChange={(value: string) =>
					!value && value.length === 0 ? updatePhoneNumber(null) : updatePhoneNumber(value)}
				errorMessage={showInvalids && invalidFormValue(phoneNumber)
					? t('validation.requiredField')
					: showInvalids && !isValidPhoneNumber(phoneNumber)
					? t('validation.incorrectPhoneFormat')
					: undefined} />

		</div>
	);
};

export default CLientInfo;